// Global console log control
// Import this as early as possible (in main.tsx) so it patches console before app loads

// In development: allow all logs (do not suppress anything)
// In production: suppress everything except errors
const isDev = import.meta.env.DEV;

if (!isDev) {
  const noop = () => {};
  (console as any).log = noop;
  (console as any).info = noop;
  (console as any).debug = noop;
  (console as any).warn = noop;
}

export {}; // make this a module

